import Tables from "../../reusableComponents/Tables/Table/TableCard";
import React, { useState, useEffect } from 'react';
import { addDepartment, getDepartementsList } from "../../axios-client";
import AddDepartmentDialog from "./AddDepartmentDialog";
import { IconButton } from '@mui/material';
import Edit from '@mui/icons-material/Edit';
import EditDepartmentDialog from "./EditDepartmentDialog";
import SnackbarNotification from "../../reusableComponents/Snackbar/SnackbarNotification";
import { formatDataToUrlQueryParams } from "../../utlis/generalUtils";
import { useTranslation } from "react-i18next";

const Departments = () => {
    const { t, i18n } = useTranslation('departments');
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openAddDepartmentDialog, setOpenAddDepartmentDialog] = useState(false);
    const [openEditDepartmentDialog, setOpenEditDepartmentDialog] = useState(false);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [notification, setNotification] = useState({ show: false, snackbarMessage: '', severity: "" });
    const [departmentsCount, setDepartmentsCount] = useState(0);

    const [filterData, setFilterData] = useState({
        page: 1,
        size: 10,
    });

    const fetchData = (filterData = {}) => {
        const queryParams = formatDataToUrlQueryParams(filterData);
        getDepartementsList(`?${queryParams}`)
            .then(res => {
                const formattedRows = res.data.departments.map(department => ({
                    [t("table_headers.department_name")]: department.name,
                    [t("table_headers.university")]: department.university.name,
                    [t("table_headers.max_users")]: department.max_users,
                    [t("table_headers.phone")]: department.phone,
                    [t("table_headers.action")]: (
                        <IconButton
                            onClick={() => handleOpenEditDialog(department)}
                            style={{ cursor: 'pointer' }}
                            size="small"
                        >
                            <Edit />
                        </IconButton>
                    ),
                }));

                setDepartmentsCount(res.data.count);
                setRows(formattedRows);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching departments:', error);
                setLoading(false);
            });
    };

    const handleOpenEditDialog = (department) => {
        setSelectedDepartment(department);
        setOpenEditDepartmentDialog(true);
    };

    const handleCloseEditDialog = () => {
        setOpenEditDepartmentDialog(false);
        setSelectedDepartment(null);
    };

    useEffect(() => {
        if (filterData) {
            fetchData(filterData);
        }
    }, [filterData, i18n.language]);

    const handleAddDepartment = async (formData) => {
        const { department, university, phone, maxUsers } = formData;

        const data = {
            name: department,
            university_id: university,
            phone,
            max_users: maxUsers
        };

        try {
            await addDepartment(data);
            fetchData(filterData);
            setOpenAddDepartmentDialog(false);
            setNotification({
                show: true,
                snackbarMessage: t("notification.add_success"),
                severity: "success"
            });
        } catch (error) {
            console.error('Error adding department:', error);
            setNotification({
                show: true,
                snackbarMessage: t("notification.add_error"),
                severity: "error"
            });
        }
    };

    const handleOpenDialog = () => setOpenAddDepartmentDialog(true);
    const handleCloseDialog = () => setOpenAddDepartmentDialog(false);

    const handlePageChange = (newPage) => {
        setFilterData((prev) => ({ ...prev, page: newPage }));
    };

    const handleRowsPerPageChange = (newSize) => {
        setFilterData((prev) => ({ ...prev, size: newSize, page: 1 }));
    };

    return (
        <>
            <Tables
                rows={rows}
                title={t("title")}
                showAddButton={true}
                ButtonName={t("button.add")}
                onButtonClick={handleOpenDialog}
                loadingData={loading}
                size={filterData.size}
                page={filterData.page}
                handlePageChange={handlePageChange}
                handleRowsPerPageChange={handleRowsPerPageChange}
                count={departmentsCount}
            />

            {openAddDepartmentDialog && (
                <AddDepartmentDialog
                    open={openAddDepartmentDialog}
                    onClose={handleCloseDialog}
                    handleAddDepartment={handleAddDepartment}
                />
            )}
            {openEditDepartmentDialog && (
                <EditDepartmentDialog
                    open={openEditDepartmentDialog}
                    onClose={handleCloseEditDialog}
                    onDepartmentAdded={fetchData}
                    departmentData={selectedDepartment}
                    setSnackbar={setNotification}
                />
            )}

            <SnackbarNotification
                notification={notification}
                setNotification={setNotification}
            />
        </>
    );
};

export default Departments;
